import { Crisp } from 'crisp-sdk-web'

import { SUPPORT_EMAIL } from '@/config/appConstants'

export const openContactChat = (message: string = '') => {
  try {
    const isCrispLoaded = Crisp.session.getIdentifier()

    if (isCrispLoaded) {
      Crisp.chat.show()
      Crisp.chat.open()
      if (message) {
        Crisp.message.send('text', message)
      }
    } else {
      window.open(`mailto:${SUPPORT_EMAIL}`)
    }
  } catch (error) {
    window.open(`mailto:${SUPPORT_EMAIL}`)
  }
}
